export default (theme) => ({
  colorIcon: {
    color: "black !important",
    marginLeft: 10,
    marginTop: 8,
  },
  popoverBody: {
    // width: "500px",
    "&&a": {
      textDecoration: "none !important",
      "&&:hover": {
        textDecoration: "none !important",
      },
    },
  },
  paperClass: {
    boxShadow: "none",
    backgroundColor: "transparent",
    overflow: "hidden",
    width: "90%",
    maxWidth: "800px",
    padding: "3px",
  },
  badge: {
    position: 'absolute',
    background: "#F1414E",
    height: 18,
    width: 18,
    borderRadius: 18,
    fontSize: 12,
    top: 3,
    right: 8,
    color: "white",
    fontWeight: 600
  },
  container: {
    position: "relative",
    // marginRight: 25,
    cursor: "pointer",
  },
  cardHeader: {
    background: theme.palette.lightGrey,
    border: "none",
    borderRadius: 0,
  },
  subheader: {
    fontSize: theme.fontSize,
    color: theme.palette.darkBlack,
    fontWeight: 500,
  },
  action_volume: {
    color: theme.palette.hint.main,
    margin: "auto 0",
    fontSize: 30,
    cursor: "pointer",
  },
  root: {
    borderRadius: 0,
    width: "100%",
    height: "100%",
    boxShadow:
      "0px 1px 5px 0px rgba(0, 0, 0, 0.2),0px 2px 2px 0px rgba(0, 0, 0, 0.14),0px 3px 1px -2px rgba(0, 0, 0, 0.12)",
  },
  card_content: {
    maxHeight: "400px",
    overflowY: "scroll",
  },
  withoutPadding: {
    padding: 0,
    "&:last-child": {
      paddingBottom: 0,
    },
  },
  btnlink: {
    margin: "0 !important",
    color: "#26bbed!important",
    fontSize: "14px!important",
  },
  bodyContainer: {
    marginTop: 10,
  },
  bodyContainerorg: {
    marginTop: 12,
  },
  arrow: {
    width: 0,
    height: 1,
    position: "relative",
    top: "0px",
    left: `calc(100% - ${theme.margins.xs + 22}px)`,
    transform: "translate(50%,0)",
    [theme.breakpoints.up("md")]: {
      left: `calc(100% - ${theme.margins.xs + 22}px)`,
      transform: "translate(50%,0)",
    },
    borderBottom: `10px solid ${theme.palette.lightGrey} !important`,
    borderRight: `10px solid transparent !important`,
    borderLeft: `10px solid transparent !important`,
    borderTop: `10px solid transparent !important`,
  },
});